export default class MuNavOpenActivePath {
    _hasActivePath = false;
    _$parents = [];
    constructor(selector, callback) {
        this._callback = callback;      
        this._nav =
            typeof attribute === "string"
                ? document.querySelector(selector)
                : selector;
  
        if (this._nav) {
            this.active();
        }
    }

    get hasActivePath() {
        return this._hasActivePath;
    }

    last() {
        return this._$parents.length > 0 ? this._$parents.last() : null;
    }

    active() {
        let $active = $(".is-active", this._nav);
        if ($active.length > 0) {
            $active.attr("aria-current", "page");
            this._$parents = $active.parents(".has-children");
        }
        if (this._$parents.length > 0) {
            this._$parents
                .addClass("is-open")
                .addClass("is-active is-active-parent")
                .attr("aria-expanded", true);
            this._hasActivePath = true;
        }
    }
}
